import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import WithRouter from '../Layout/Router/WithRouter';
import PageNavigationCard from '../common/PageNavigationCard';

class AdminPanel extends Component {
  state = {
    adminPages: [
      { id: 'tutoring', page: 'tutoring', title: 'Tutoring' },
      { id: 'locations', page: 'locations', title: 'Locations' },
      { id: 'feedback', page: 'feedback', title: 'Feedback' },
      {
        id: 'cognitoErrorLog',
        page: 'cognito-error-log',
        title: 'Cognito Error Log',
      },
      {
        id: 'frontendErrorLog',
        page: 'frontend-error-log',
        title: 'FE Error Log',
      },
    ],
  };
  render() {
    return (
      <React.Fragment>
        <div
          id={'adminPanel__div_contentWrapper'}
          className="myOdu__container_maxWidth"
          style={{ marginTop: '2rem' }}
        >
          <h4 id={'adminPanel__text__adminPanelTitle'}>Admin Panel</h4>
          <Row id={'adminPanel__col_tutoringAndLocations'} className="g-3">
            {this.state.adminPages.map((item) => (
              <Col id={`adminPanel__col_${item.page}`} md={3}>
                <PageNavigationCard id={'admin'} url={'admin'} subPage={item} />
              </Col>
            ))}
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default WithRouter(AdminPanel);
